/** English text for orders, order detail, receipts, preferences and shared dialog buttons. Each value is also its translation key. */
export const B = {
  cancel: 'Cancel',
  keepIt: 'Keep it',
  del: 'Delete',
  deleting: 'Deleting…',
  nothingYet: 'Nothing here yet',
  choose: 'Choose…',
  save: 'Save',
  saving: 'Saving…',
  renewal: 'Renewal',

  codeShape: 'Order numbers look like GC-7K2QXM: GC- and then six letters or numbers',
  noOrderCode: 'No order {code} on your account',
  checkReceipt: 'Check the number on your receipt or message us.',
  cantCheck: 'Could not check that order. Try again in a moment.',
  ordersDesc: "Every line and licence you've ordered, newest first. Have an order number? Type it in to jump straight to it.",
  privateN: 'Private {name} packages',
  inviteOnly: 'Invitation-only pricing for Ghost Cable customers. Please keep these links to yourself.',
  seeN: 'See {name}',
  compareThree: 'Compare all three plans',
  allStatuses: 'All statuses',
  noStatus: 'No orders with this status',
  firstOrder: 'Your first order shows up here as soon as you send it.',
  tryStatus: 'Try another status.',
  colOrder: 'Order',
  colPackage: 'Package',
  colStatus: 'Status',
  colOrdered: 'Ordered',
  colEnds: 'Term ends',

  labelCopied: '{label} copied',
  cantCopyIt: 'Could not copy. Select it and copy by hand.',
  backOrders: 'Back to Orders',
  notFound: 'Order not found',
  notFoundP: 'It may have been deleted, or it belongs to another account.',
  cancelled: 'Order cancelled',
  deleted: 'Order deleted',
  orderedOn: 'Ordered {date}',
  cancelOrder: 'Cancel order',
  cancelQ: 'Cancel this order?',
  cancelP: "We'll stop preparing it. You can place a new order whenever you like.",
  cancelling: 'Cancelling…',
  deleteQ: 'Delete this order?',
  deleteP: '{code} disappears from your account. This cannot be undone.',
  yourLine: 'Your line',
  server: 'Server',
  username: 'Username',
  password: 'Password',
  epgIncl: 'Premium TV guide (EPG) included',
  sentWhen: 'Sent {when}',
  lineSoon: 'Your line details appear here as soon as it is switched on.',
  licenceKey: 'Licence key',
  copyKey: 'Copy key',
  getPlayer: 'Get the player',
  keySoon: 'Your licence key appears here as soon as payment is confirmed.',
  billing: 'Billing',
  price: 'Price',
  discountL: 'Discount',
  noRefund: 'No-refund policy',
  acceptedOn: 'Accepted {date}',
  dates: 'Dates',
  activated: 'Activated',
  renewalReq: 'Renewal requested',
  orderDetails: 'Order details',
  name: 'Name',
  email: 'Email',
  contact: 'Contact',
  device: 'Device',
  adult: 'Adult content',
  included: 'Included',
  notIncluded: 'Not included',
  freeTrial: 'Free trial',
  requested: 'Requested',
  notesL: 'Notes',
  payments: 'Payments',
  loadingPay: 'Loading payments…',
  noPay: 'No payments recorded yet.',
  helpOrder: 'Get help with this order',
  writeReview: 'Write a review',

  receiptsDesc: "Every payment we've recorded against your orders. Download any of them as a PDF.",
  allPayments: 'All payments',
  noReceipts: 'No receipts yet',
  noReceiptsP: 'Receipts appear here once we confirm a payment on one of your orders.',
  colType: 'Type',
  colMethod: 'Method',
  colPaidOn: 'Paid on',
  download: 'Download',
  pdfDone: 'Receipt downloaded',
  pdfFail: 'Could not build the PDF. Try again.',
  preparing: 'Preparing…',

  addName: 'Add the name we should use',
  prefsSaved: 'Preferences saved',
  refCopied: 'Referral code copied',
  prefsDesc: 'How we reach you, and which emails you get.',
  profile: 'Profile',
  emailHint: 'Your sign-in email. Change it to sign in with a new address.',
  change: 'Change',
  contactApp: 'Contact app',
  chooseApp: 'Choose an app',
  handle: 'Handle',
  handleHint: 'Where we send setup help if email is slow.',
  expiry: 'Expiry reminders',
  expiryHint: 'A heads-up a week before a line ends, so nothing goes dark mid-season.',
  offersNews: 'Offers and news',
  offersHint: 'New plans, holiday deals and the odd ghost story. A few emails a year.',
  unsubOn: 'You unsubscribed from offers on {date}.',
  refCode: 'Referral code',
  refCodeHint: 'Share it with a friend. Mention it in a ticket once they order.',
  savePrefs: 'Save preferences',
  createProfile: 'Create my profile',
  detailsDesc: 'Your name and the email you sign in with. Your orders move with you.',
};
